export const TOP_MENU_CLASS_BLOCK_NAME = 'bb-menu-tabs';
export const MENU_TAB_CLASS_BLOCK_NAME = `${TOP_MENU_CLASS_BLOCK_NAME}__tab`;
export const MENU_TAB_SELECTED_MODIFIER = 'selected';
export const MENU_TAB_FLUID_MODIFIER = 'fluid';
export const MENU_TAB_MAX_WIDTH_75 = 'max-width-75';

export const MENU_TAB_LABEL_CLASS_NAME = `${TOP_MENU_CLASS_BLOCK_NAME}__label`;
export const MENU_TAB_COUNTER_CLASS_NAME = 'bb-counter-events';
export const MENU_TAB_COUNTER_HIDDEN_MODIFIER = `${MENU_TAB_COUNTER_CLASS_NAME}--hidden`;
